module.exports = __webpack_public_path__ + "img/img (60).583377d8.jpg";